import React from "react";
import "./sidebar.scss";
import { Link, useLocation } from "react-router-dom";
import {
  Home,
  InsertDriveFile,
  Storage,
  WatchLater,
  Feedback,
  Description,
  History,
} from "@mui/icons-material";
import { MdLockReset, MdOutlinePowerSettingsNew } from "react-icons/md";

function Sidebar({ stateVal, trigger }) {
  const location = useLocation();
  const { pathname } = location;

  const closeSideMenu = () => {
    if (window.innerWidth < 992) {
      trigger();
    }
  };
  return (
    <div className={`sidebar sidebarContainer ${stateVal ? "" : "d-none"}`}>
      <div className="sidebarContent">
        <Link
          to="/"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/" ? "subContent mb-2 active" : "subContent mb-2"
            }
          >
            <Home className="icon" />
            <p className="actualText">Home</p>
          </div>
        </Link>
        {/* import */}
        {/* <Link
          to="/import"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/import"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <InsertDriveFile className="icon" />
            <p className="actualText">Import</p>
          </div>
        </Link> */}
         {/* /reference-data */}
         
        <Link
          to="/import"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/import"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <InsertDriveFile className="icon" />
            <p className="actualText">Import</p>
          </div>
        </Link>
       

        {/* /data-processing */}
        {/* <Link
          to="/data-processing"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-processing"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Storage className="icon" />
            <p className="actualText">Data Processing</p>
          </div>
        </Link> */}
        {/* <Link
          to="/data-processing-new"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-processing-new"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Storage className="icon" />
            <p className="actualText">Data Processing</p>
          </div>
        </Link> */}

        {/* <Link
          to="/data-processing-new3"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-processing-new3"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Storage className="icon" />
            <p className="actualText">Data Processing-1</p>
          </div>
        </Link> */}
        <Link
          to="/data-processing-new4"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-processing-new4"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Storage className="icon" />
            <p className="actualText">Data Processing</p>
          </div>
        </Link>
        {/* /data-selection */}
        {/* <Link
          to="/data-selection"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-selection"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <WatchLater className="icon" />
            <p className="actualText">Data Selection</p>
          </div>
        </Link> */}
        {/* /data-selection-new */}
        {/* <Link
          to="/data-selection-new"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-selection-new"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <WatchLater className="icon" />
            <p className="actualText">Data Selection</p>
            
          </div>
        </Link> */}
        {/* /data-selection-new2 */}
        {/* <Link
          to="/data-selection-new2"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-selection-new2"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            } 
          >
            <WatchLater className="icon" />
            <p className="actualText">Data Selection</p>
          </div>
        </Link>
        <Link
          to="/data-selection-new3"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-selection-new3"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            } 
          >
            <WatchLater className="icon" />
            <p className="actualText">Data Selection-1</p>
          </div>
        </Link> */}
        <Link
          to="/data-selection-new4"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/data-selection-new4"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            } 
          >
            <WatchLater className="icon" />
            <p className="actualText">Data Selection</p>
          </div>
        </Link>
        {/* /reports */}
        <Link
          to="/reports"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/reports"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Feedback className="icon" />
            <p className="actualText">Reports</p>
          </div>
        </Link>
        {/* /history */}
        <Link
          to="/history"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/history"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <History className="icon" />
            <p className="actualText">Historical Data</p>
          </div>
        </Link>
        <Link
          to="/reference-data"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/reference-data"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <InsertDriveFile className="icon" />
            <p className="actualText">Reference Data</p>
          </div>
        </Link>
        
        {/* Compare */}
        <Link
          to="/delisted-entity"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/delisted-entity"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Description className="icon" />
            <p className="actualText">Delisted Entity</p>
          </div>
        </Link>
        {/* <Link
          // to="/raw-data-import"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/raw-data-import"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <InsertDriveFile className="icon" />
            <p className="actualText">Raw Data Import</p>
          </div>
        </Link>
        <Link
          to="/efficiency-report"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link align-items-center"
        >
          <div
            className={
              pathname === "/efficiency-report"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <Assessment className="icon" />
            <p className="actualText">Efficiency Report</p>
          </div>
        </Link> */}
        {/* reset password */}
         <Link
          to="/reset-password"
          onClick={() => {
            closeSideMenu();
          }}
          className="sidebar-link"
        >
          <div
            className={
              pathname === "/reset-password"
                ? "subContent mb-2 active"
                : "subContent mb-2"
            }
          >
            <MdLockReset className="icon" />
            <p className="actualText">Reset Password</p>
          </div>
        </Link>
        {/* logout */}
        {/* <Link
          // to="/login"
          onClick={() => {
            closeSideMenu();
            localStorage.clear();
          }}
          className="sidebar-link"
        >
          <div className="subContent mb-2">
            <MdOutlinePowerSettingsNew className="icon" />
            <p className="actualText">Log Out</p>
          </div>
        </Link> */}
      </div>
    </div>
  );
}

export default Sidebar;
